import { Injectable, EventEmitter } from "@angular/core";
import { Events } from "ionic-angular";
import { INVARIANT } from "../../../../config";
import { Observable } from "rxjs";
import { Badge } from "@ionic-native/badge";
import { StorageService } from "../../storage/storage.service";

@Injectable()
export class EventService {
  public evExitLogin: EventEmitter<any> = new EventEmitter(); //退出登录
  public evPoptoTabs: EventEmitter<any> = new EventEmitter(); //重定向到tabs页面

  constructor(
    public events: Events,
    private badge: Badge,
    private storageSer: StorageService,
  ) {}

  /**
   * 变更badge数量
   * @param args
   */
  badgeEvSet(...args) {
    return this.events.publish(INVARIANT._EVENTS_BADGE, args);
  }

  /**
   * 订阅badge数量
   */
  badgeEvGet(): Observable<any> {
    return Observable.create((observer) => {
      this.events.subscribe(INVARIANT._EVENTS_BADGE, (num) => {
        this.storageSer
          .getStore(INVARIANT._SYS_BADGE_SUPPORT_PERMISSION)
          .then((res) => {
            if (res) {
              this.badge.clear();
              this.badge.set(num);
            }
          });
        observer.next(num);
      });
    });
  }

  /**
   * 页面返回 目标页面是否刷新
   * @param arg
   */
  backEvSet(id, arg: BackParams) {
    return this.events.publish(INVARIANT._EVENTS_PAGEBACK + `_${id}`, arg);
  }

  backEvGet(id): Observable<any> {
    return Observable.create((observer) => {
      this.events.subscribe(INVARIANT._EVENTS_PAGEBACK + `_${id}`, (arg) => {
        observer.next(arg);
      });
    });
  }
}

class BackParams {
  pageName: string;
  params: any;
}



// WEBPACK FOOTER //
// ./src/services/common/app/event/event.service.ts